import { createContext, useContext } from "react";

/**
 * The dialog's own content element, for anything that has to render *inside* it.
 *
 * Radix wraps a modal dialog's content in `react-remove-scroll`, which listens
 * on the document and cancels every wheel event whose target is not inside that
 * element (or one of its `shards`, which Radix does not expose). A menu
 * portalled to `document.body` is therefore outside the lock: it scrolls by
 * keyboard and by dragging its bar, and sits dead under a trackpad — which is
 * exactly how the bug reads to the person using it.
 *
 * So a popover-backed control opened from inside a dialog portals *into* this
 * node instead. `null` outside a dialog, where the default body portal is
 * right and nothing is locking scroll.
 */
export const DialogPortalContainerContext = createContext<HTMLElement | null>(null);

/** The dialog to portal into, or `null` when there is no dialog above. */
export function useDialogPortalContainer(): HTMLElement | null {
  return useContext(DialogPortalContainerContext);
}
